import request from '@/axios'

// 配额列表
export function getApi(data={}) {
    return request({
        url: '/pay/quota/list',
        method: 'get',
        params: data
    })
}
// 某个配额
export function getApi1(id) {
    return request({
        url: `/pay/quota/info/${id}`,
        method: 'get',
        // params: data
    })
}
// 新增配额
export function addApi(data={}) {
    return request({
        url: `/pay/quota/save`,
        method: 'post',
        data: data
    })
}
// 修改配额
export function updateApi(data={}) {
    return request({
        url: `/pay/quota/update`,
        method: 'post',
        data: data
    })
}
// 删除配额
export function delApi(data={}) {
    return request({
        url: `/pay/quota/delete`,
        method: 'post',
        data: data
    })
}